import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { toast } from "react-toastify";
import { residences } from "../services/soar";
import NewResidenceModal from "./NewResidenceModal";
import ApartmentNotes from "../apartments/ApartmentNotes";
import HomeButtonBar from "../pipeline/HomeButtonBar";
import HomeApplicants from "../pipeline/HomeApplicants";
import FPTiers from "./FPTiers";
import ResidenceBeds from "./ResidenceBeds";
import FPInvestigations from "../FPInvestigations";

function ResidenceFosterHome(props) {
  const params = useParams();
  const [residenceData, setResidenceData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [bintiData, setBintiData] = useState({});
  const [updateData, setUpdateData] = useState(false);
  const [activeTab, setActiveTab] = useState("beds");
  const navigate = useNavigate();
  const applicationId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
      : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

  useEffect(() => {
    getResidenceData();
  }, []);

  useEffect(() => {
    if (updateData) {
      getResidenceData();
      setUpdateData(false);
    }
  }, [updateData]);

  const getResidenceData = async () => {
    const body = {
      command: "query",
      application: applicationId,
      keyword: "byid",
      ids: [params.id],
    };
    const data = await residences(body);
    setResidenceData(data.data[0]);
    if (data.data[0]?.binti?.length > 0) {
      setBintiData(data.data[0].binti[0]);
    }
  };

  const handleActivateDeactivate = async () => {
    const body = {
      command: residenceData.active ? "deactivate" : "reactivate",
      application: applicationId,
      id: residenceData.id,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };
    const response = await residences(body);
    if (response.code === "success") {
      setResidenceData({ ...residenceData, active: !residenceData.active });
      toast.success(`${residenceData.active ? "Deactivated" : "Activated"}`);
    } else {
      toast.error("Error updating apartment status");
    }
  };

  const handleSave = async () => {
    let body = {
      command: residenceData.id ? "update" : "create",
      application: applicationId,
      name:
        residenceData.name !== "" ? residenceData.name : residenceData.address,
      type: residenceData.type,
      externalIdentifier: residenceData.externalIdentifier,
      address: residenceData.address,
      city: residenceData.city,
      state: residenceData.state,
      zip: residenceData.zip,
      unit: residenceData.unit,
      doorCode: residenceData.doorCode,
      leaseStatus: residenceData.leaseStatus,
      placementStatus: residenceData.placementStatus,
      programUnit: residenceData.programUnit,
      programUnitName: residenceData.programUnitName,
      company: residenceData.company,
      companyName: residenceData.companyName,
    };

    if (residenceData.id) {
      body.id = residenceData.id;
    }

    return await residences(body);
  };
  return (
    <>
      <NewResidenceModal
        data={residenceData}
        setData={setResidenceData}
        show={showModal}
        handleSave={handleSave}
        onHide={() => setShowModal(false)}
        updateData={() => setUpdateData(true)}
      />
      <div
        className={residenceData.active === false ? "bg-warning p-2" : "p-2"}
      >
        <div>
          <div className="row">
            <div className="col-4 d-flex">
              {residenceData.binti?.length > 0 && (
                <div
                  className="rounded card-safy text-safy-info me-2"
                  style={{ width: "80px", height: "80px" }}
                >
                  <HomeButtonBar
                    application={{
                      HomeData: residenceData.binti || [],
                    }}
                  />
                </div>
              )}
              <div className="mb-4">
                <div
                  className="h5 btn btn-primary"
                  onClick={() =>
                    window.open(
                      `https://family.binti.com/admin/applications/${bintiData["application-id"]}`
                    )
                  }
                >{`BINTI ID: ${residenceData.externalIdentifier}`}</div>
                {/* <div>
                  <i
                  className="fas fa-map-pin text-danger me-2"
                  onClick={() =>
                    window.open(
                      `https://maps.google.com/?q=${residenceData.address} ${residenceData.city} ${residenceData.state}`
                      )
                      }
                      />{" "}
                      {`${residenceData.address}, ${residenceData.city}, ${residenceData.state} ${residenceData.zip}`}
                      </div> */}

                <div className="h4 fw-bold">{`${
                  bintiData ? bintiData["application-home-name"] : ""
                }`}</div>
              </div>
            </div>

            <div className="col-3 pt-2">
              <HomeApplicants
                application={{
                  HomeData: residenceData.binti || [],
                }}
              />
            </div>
            <div className="col-3">
              <div className="h6 my-2">
                {`State: ${residenceData.companyName}`}
              </div>
              <div className="h6">{`Capacity: ${bintiData.capacity}`}</div>
              <div className="h6">{`Ages ${bintiData["approved-age-lower"]} - ${bintiData["approved-age-higher"]}`}</div>
              {residenceData.active === false && (
                <div className="text-danger fw-bold m-4 h5">Inactive</div>
              )}
            </div>
            <div className="col-2 ">
              <i
                className="fas fa-pen rounded border border-dark bg-primary text-white p-2 ms-2 float-end"
                onClick={() => setShowModal(!showModal)}
              />

              <i
                className={`fas ${
                  residenceData.active
                    ? "fa-trash bg-danger"
                    : "fa-trash-can-arrow-up bg-success"
                } rounded border border-dark text-white p-2 ms-2 float-end`}
                role="button"
                onClick={handleActivateDeactivate}
              />
            </div>
          </div>
          <div className="row my-4">
            <Tabs
              activeKey={activeTab}
              id="fhtabs"
              className="cptabs mb-4"
              transisiton="false"
              onSelect={(key) => {
                setActiveTab(key);
              }}
            >
              <Tab eventKey="beds" title="Beds">
                <ResidenceBeds
                  data={residenceData}
                  setData={setResidenceData}
                  updateData={() => setUpdateData(true)}
                />
              </Tab>
              <Tab eventKey="Tiers" title="Tiers">
                <FPTiers
                  data={residenceData}
                  refreshData={() => setUpdateData(true)}
                />
              </Tab>
              <Tab eventKey="rulesViolation" title="Rules Violation">
                <FPInvestigations
                  fosterHome={{
                    fosterhomeid: residenceData.id,
                  }}
                />
              </Tab>
            </Tabs>
          </div>
          {/* <PropertyContacts
            data={residenceData}
            refreshData={() => getResidenceData()}
          /> */}
          {/* <ApartmentRelated
            data={residenceData}
            refreshData={() => getResidenceData()}
          /> */}
        </div>
      </div>
    </>
  );
}

export default ResidenceFosterHome;
